import React, {Component} from "react";
import {Drawer, message, Select} from "antd";
import {CloseOutlined} from '@ant-design/icons';
import {map, isEmpty, cloneDeep, toNumber} from "lodash";
import Script from "react-load-script";
import * as yup from 'yup'
import CurrencyFormat from 'react-currency-format';
// import moment from "moment-timezone";
import cross_icon from "../../../../../Assets/images/cross_icon.svg";
import plus_icon from "../../../../../Assets/images/plus_icon.svg";
import plus_icon_green from "../../../../../Assets/images/add-circle-outline-green.svg";
import Loader from "../../../../Common/Component/Loader";
import AllState from "../../../../../Assets/data/stateList.json";
// import axios from 'axios';
// import config from '../../../../../Lib/Config';
import Axios from "axios";
import { formatToCurrency } from "../../../../../Tools/formatToCurrency";

const { Option } = Select;


function removeEmpty(obj) {
  return Object.fromEntries(Object.entries(obj).filter(([_, v]) => (v !== null && v?.trim() !== "")));
}

// mapping frequency for hardcoded
const FREQUENCY_MAPPING = [
  {
    value: 'weekly',
    key: 'Weekly',
  },
  {
    value: 'bi_monthly',
    key: 'Every Other Week',
  },
  {
    value: 'once',
    key: 'Just Once',
  },
  {
    value: 'twice_weekly',
    key: 'Twice Weekly',
  },
  {
    value: 'monthly',
    key: 'Monthly',
  }];

// mapping frequency  for hardcoded
const PROPERTY_TYPE_MAPPING = [
  {
    value: 'townhouse',
    key: 'Town House',
  },
  {
    value: 'single_family_small',
    key: 'Detached (Less than 0.5 acres. lot)',
  },
  {
    value: 'single_family_large',
    key: 'Detached (More than 0.5 acres. lot)',
  }];

// mapping for cleaning areas
const formattedAreas = [
  { display: 'Front Yard', value: 'front yard'},
  { display: 'Back Yard', value: 'back yard'},
  { display: 'Right Side', value: 'right side'},
  { display: 'Left Side', value: 'left side'},
  { display: 'Dog Run', value: 'dog run'},
  { display: 'Fenced Area', value: 'fenced area'},
  // { display: 'Other', value: ''},
];

// mapping for days
const days = ['sun', 'mon', 'tues', 'wed', 'thurs', 'fri', 'sat'];

class EditService extends Component {
  state = {
    tech: '',
    tech_list: {},
    uuid: '',
    location: {
      address: '',
      city: '',
      state: '',
      zip_code: ''
    },
    regularity: '',
    propertySize: '',
    cleaningAreas: '',
    depositLocation: '',
    preferredServiceDays: [],
    securityCode: '',
    notes: '',
    total_price_per_service: '',
    addOns: [],
    isDoggyDoor: false,
    cleanOutside: false,
    is_btn_active: false,
    errors: {},
    miscellaneous: [],
    mis_type:'',
    org_miscellaneous: [],
    service_add_ons: [],
    loader: false,
    total: 0,
    total_addons: 0,
    service: {},
    total_price_per_service_incl_miscellaneous: 0,
    is_address_manually: false,
    is_google_init: false,
    renderErrorFromProps: false,
  }

  componentDidMount = () => {
    this.setServiceDetail(this.props);
  }
  
  UNSAFE_componentWillReceiveProps = (nextProps) => {
    
    if(this.state.renderErrorFromProps && !!nextProps?.Service?.errors?.service_address && nextProps?.Service?.errors?.service_address?.length > 0) {
      this.setState({
        errors: {
          ...this.state.errors,
          "location.address": nextProps?.Service?.errors?.service_address?.[0] || "Address Is Required"
        },
        renderErrorFromProps: false
      })
    }

    if(Object.keys(nextProps?.Service?.data || {}).length > 0 && (!nextProps?.Service?.errors?.service_address || nextProps?.Service?.errors?.service_address?.length === 0)) {
      // nextProps.closeDrawer();
      nextProps.editService();
    }

    if(!!window?.google?.maps?.places && !this.state.is_google_init) {
      this.handleScriptLoad();
      this.setState({is_google_init: true})
    }

    // message.destroy()
    if (nextProps?.service && JSON.stringify(nextProps?.service) !== JSON.stringify(this.state.service)) {
      this.setServiceDetail(nextProps);
    }

    // get add ons
    if (Object.keys(nextProps?.addOns).length > 0) {
      this.setState({ addOns: nextProps?.addOns, loader: false});
    }

    if (Object.keys(nextProps?.Service?.pauseService).length > 0 &&
      JSON.stringify(nextProps?.Service?.pauseService) !== JSON.stringify(this.props?.Service?.pauseService)) {
      this.setState({loader: false, pauseService: nextProps?.Service?.pauseService})
      this.props.viewService({ service_order__uuid: this.state.uuid, limit: 10, offset: 0 });
      // this.props.closeDrawer();
      this.onClear();
    }

    // get pricing calc
    if (Object.keys(nextProps?.PricingCalc?.data).length > 0
      && JSON.stringify(nextProps?.PricingCalc?.data) !== JSON.stringify(this.props.PricingCalc?.data)) {
      this.setState({ total_price_per_service: nextProps?.PricingCalc?.data?.total_price_per_service, loader: false});
    }

    // get geocode
    if (Object.keys(nextProps?.GoogleApi?.getGeocode) && JSON.stringify(nextProps?.GoogleApi?.getGeocode) !== JSON.stringify(this.props?.GoogleApi?.getGeocode)) {
      this.setAddress(nextProps?.GoogleApi?.getGeocode)
    }

    // Get list of technician
    if (Object.keys(nextProps?.fieldTechnician?.technicianList).length > 0
      && JSON.stringify(nextProps?.fieldTechnician?.technicianList) !== JSON.stringify(this.state.tech_list)) {
      this.setState({ tech_list: nextProps?.fieldTechnician?.technicianList });
    }

    this.setState({ loader: false })
  }

  setServiceDetail = (nextProps) => {
    const {service, addOns} = nextProps;
    const preferredServiceDays = days?.filter(x => !service?.service_unavailable_days?.includes(x)).length < 7  ? days?.filter(x => !service?.service_unavailable_days?.includes(x)) : ['any'];
    const service_add_ons = service?.service_add_ons?.map(x => ({...x, checked: true}))
    let total_addons = 0;

    map(service_add_ons, x => {
      const data = addOns.find(y => y.uuid === x.add_on_uuid)
      if (!isEmpty(data)) {
        total_addons += data?.cost_per_visit
      }
    });

    this.props.getFieldTechnicianList({field_office__uuid: service.field_office_uuid}) // Get list of technician

    let temp_misc = !isEmpty(service?.calculated_price?.misc_services) ? service?.calculated_price?.misc_services : [];

    if(temp_misc.length > 0) temp_misc.forEach(item => item.formatted_price = formatToCurrency(item.price));

    this.setState({
      service: nextProps?.service,
      uuid: service?.uuid,
      tech: service?.preferred_technician?.uuid || '',
      location: {...service?.service_address},
      geo_location: !isEmpty(service?.service_address?.geo_location) ? `${service?.service_address?.geo_location?.latitude}, ${service?.service_address?.geo_location?.longitude}` : '',
      regularity: service?.frequency,
      propertySize: service?.property_type,
      cleaningAreas: service?.area_to_clean,
      depositLocation: service?.disposal_location,
      preferredServiceDays: preferredServiceDays || [],
      securityCode: service?.security_code ? service?.security_code : '',
      notes: service?.cleaning_notes,
      isDoggyDoor: service?.has_doggy_door,
      cleanOutside: service?.is_dogs_outside,
      total_price_per_service: service?.calculated_price?.total_price_per_service,
      org_miscellaneous: temp_misc,
      miscellaneous: temp_misc,
      service_add_ons: service_add_ons || [],
      loader: false,
      total_addons,
      total_price_per_service_incl_miscellaneous: service?.calculated_price?.total_price_per_service_incl_miscellaneous || 0,
      addOns: nextProps?.addOns
    }, () => {
      this.onTotalPerVisitChanged();
      const {location} = this.state;
      let address = location?.address ? `${location?.address}` : '';
      address += location?.city ? `, ${location?.city}` : '';
      address += location?.state ? `, ${location?.state}` : '';
      address += location?.zip_code ? `, ${location?.zip_code}` : '';

      if (this.refs['location']) {
        this.refs['location'].value = address;
      }
      // this.onTotalPerVisitChanged()
      // this.validate()
    });
  }

  // set address
  setAddress = (addressObject, geo_location_old) => {
    if (!isEmpty(addressObject)) {
      if (addressObject?.status === "OK") {
        let geo_location = '';
        let obj = {}, components = addressObject?.results?.[0];
        map(components?.address_components, (item) => {
          if (item?.types?.includes('administrative_area_level_2')) {
            obj = Object.assign(obj, { 'county': item.short_name })
          }
          if (item?.types?.includes('route')) {
            obj = Object.assign(obj, { 'route': item.long_name })
          }
          if (item?.types?.includes('street_number')) {
            obj = Object.assign(obj, { 'street_number': item.short_name })
          }
          if (item?.types?.includes('administrative_area_level_1')) {
            obj = Object.assign(obj, { 'state': item.short_name })
          }
          if (item?.types?.includes('locality')) {
            obj = Object.assign(obj, { 'city': item.long_name })
          }
          if (item?.types?.includes('postal_code')) {
            obj = Object.assign(obj, { 'zip_code': item.short_name })
          }
        });

        obj = Object.assign(obj, { 'address': `${obj?.street_number || ''} ${obj?.route || ''}`.trim() })

        if (!isEmpty(components.geometry.location) && !geo_location_old) {
          Object.assign(obj, {geo_location: {latitude: components?.geometry?.location?.lat, longitude: components?.geometry?.location?.lng}})
          geo_location = !isEmpty(components?.geometry?.location) ? `${components?.geometry?.location?.lat}, ${components?.geometry?.location?.lng}` : ''
        }

        function isInvalid(str) {
          return !str || str.trim().length === 0;
        }

        if(isInvalid(obj?.address) || isInvalid(obj?.city) || isInvalid(obj?.state) || isInvalid(obj?.zip_code)) {
          this.setState({
            is_address_manually: true,
          })
        }

        this.setState({
          location: obj, 
          // geo_location: (geo_location_old ? geo_location_old : geo_location)
        }, () => {
          // if (!obj?.address || !obj?.state || !obj.city || !obj.zip_code) {
          //   message.error('Please enter valid location');
          // }
          // this.validate()
        });
        return {
          location: obj, geo_location
        }

      } else {
        message.error('Something went wrong while getting address')
      }
    }
  }

  // Google Map Place API
  handleScriptLoad = () => {

    // return;

    // Declare Options For Autocomplete
    const options = { componentRestrictions: { country: 'us' } };

    // Initialize Google Autocomplete
    /*global google*/ // To disable any eslint 'google not defined' errors
    const newAutoComplete = new window.google.maps.places.Autocomplete(
      document.getElementById('google_address'),
      options,
    );

    // Avoid paying for data that you don't need by restricting the set of
    // place fields that are returned to just the address components and formatted
    // address.
    newAutoComplete.setFields(['address_components', 'formatted_address']);

    // Fire Event when a suggested name is selected
    newAutoComplete.addListener('place_changed', this.handlePlaceSelect);

    this.setState({
      autocomplete: newAutoComplete,
    })
  };

  // on start place change
  handlePlaceSelect = () => {
    // const {autocomplete} = this.state;
    // const addressObject = autocomplete?.getPlace();
    // console.log({addressObject, autocomplete, data: document.getElementById('google_address').value})
    this.makeGoogleApiCall({address: document?.getElementById('google_address')?.value});
  }

  // common Price Calc
  priceCalc = () => {
    const {regularity, cleaningAreas, service_add_ons, propertySize} = this.state;
    const {service} = this.props;

    const add_ons = [];
    map(service_add_ons, obj => {
      if (obj?.add_on_uuid) add_ons.push({uuid: obj?.add_on_uuid, add_on_name: obj?.add_on_name, is_recurring: obj?.is_recurring || false})
    });
    if ((service?.field_office_uuid) && regularity && (service?.extra_pet || service?.pet_count) &&  propertySize) {
      this.setState({loader: true})
      const data = {
        'field_office_uuid': service?.field_office_uuid,
        'frequency': regularity,
        'pet_count': service?.is_extra_pet ? service?.extra_pet : service?.pet_count,
        'last_cleaned': service?.last_cleaned,
        'property_type': propertySize,
        'areas_to_clean': cleaningAreas,
        'add_ons': add_ons,
        'is_prepaid': service?.is_prepaid,
        'prepay_months': service?.is_prepaid ? service?.prepay_months : null
      }
      this.props.pricingCalculator(data)
      this.onTotalPerVisitChanged();
    }
  }

  // on text change
  onTextChange = (e, type) => {
    const name = e.target.name
    const value = type === 'bool' ? e.target.checked : e.target.value;
    this.setState({[name]: value}, () => {
      if (name === 'regularity' || name === 'propertySize' || name === 'cleaningAreas') {
        this.priceCalc()
      }
      else if(name === 'preferredServiceDays'){
        let is_any_option_selected = value.findIndex(item => item === 'any');
        if(is_any_option_selected > -1 && value.length > 1 && is_any_option_selected !== 0 ){
          this.setState({preferredServiceDays:['any']})
        }
        else if(is_any_option_selected > -1 && value.length > 1 && is_any_option_selected === 0){
          const removeAny = value.filter(item => item !== 'any');
          this.setState({preferredServiceDays:removeAny})
        }
        else if( value.length === 7 && is_any_option_selected === -1 ){
          this.setState({preferredServiceDays:['any']})
        }
        else{
          const removeAny = value.filter(item => item !== 'any');
          this.setState({preferredServiceDays:removeAny})
        }
      }
      // if (name === 'total_price_per_service') this.onTotalPerVisitChanged()
    });
  };

  makeGoogleApiCall = ({geo_location, address}) => {
    Axios.get(`https://maps.googleapis.com/maps/api/geocode/json`, {
      params: removeEmpty({
        latlng: geo_location,
        address,
        key: process.env.REACT_APP_GOOGLE_PLACE_API_KEY,
      })
    }).then((res) => {
      const result = res?.data;
      this.setAddress(result, geo_location);
    }).catch((err) => {
      console.log(err)
    })
  }

  // on geo location changed
  onGeolocationChanged = (e) => {
    const geo_location = e.target.value;
    this.setState({geo_location, is_address_manually: true})
    // if(!!geo_location) {
    //   this.makeGoogleApiCall({geo_location})
    // }
  }

  // on preferred Days Change
  onPreferredDaysChanged = (value) => {
    const isAnyInclude = value[value.length - 1] === "any";
    let newValue = [];
    if (isAnyInclude) {
      newValue = ["any"];
    } else {
      const idx = value.indexOf("any");
      if (idx > -1) value.splice(idx, 1);
      newValue = value;
    }
    this.setState({preferredServiceDays: newValue})
  };

  // validate numeric input
  onNumericInputChange = (value) => {
    const reg = /^-?\d*(\.\d*)?$/;
    return ((!isNaN(value) && reg.test(value)) || value === '' || value === '-');
  };

  onMiscellaneousPriceChange = (value, index, formattedValue) => {
    const {
      miscellaneous,
      total_addons,
      total_price_per_service,
      total_miscellaneous_price
    } = this.state;

    let errors = {};

      
    if((+parseFloat(total_price_per_service + (total_miscellaneous_price || 0) + (total_addons || 0)).toFixed(2) + value) < 0)
    {
      value = 0;
      formattedValue = "$0.00";
      errors= {miscellaneous: [{index, name: "price", message: "You can't discount more than the SO total."}]};
    }

    Object.assign(miscellaneous[index], {["price"]: value, ["formatted_price"]: formattedValue});

    this.setState({miscellaneous, errors}, () => {
      formattedValue !== "-" && this.onTotalPerVisitChanged()
    });
  }

  // on miscellaneous item add
  onMiscellaneousItemChanged = (e, index) => {
    const { miscellaneous } = this.state;

    Object.assign(miscellaneous[index], {[e.target.name]: e.target.value});

    this.setState({miscellaneous}, () => {
      this.onTotalPerVisitChanged()
    });
  }

  // on total per visit changed
  onTotalPerVisitChanged = () => {
    const {
      total_price_per_service,
      miscellaneous,
      total_addons,
      total_price_per_service_incl_miscellaneous
    } = this.state;

    let total_miscellaneous_price = 0;

    map(miscellaneous, x => {
      if (x.price) total_miscellaneous_price += parseFloat(x.price);
    });

    this.setState({total: (parseFloat(total_price_per_service || 0) + total_miscellaneous_price + total_addons).toFixed(2)})
  }

  // on miscellaneous item add
  onMiscellaneousItemAdd = () => {
    const {miscellaneous} = this.state;
    miscellaneous.push({mis_type:'' ,item: '', price: ''})
    this.setState({miscellaneous})
  }

  // on miscellaneous item add
  onMiscellaneousItemRemove = (index) => {
    const {miscellaneous} = this.state;
    miscellaneous.splice(index, 1)
    this.setState({miscellaneous})
    this.onTotalPerVisitChanged();
  }

  // validate required fields
  validate = () => {
    const {
      tech,
      location,
      regularity,
      propertySize,
      cleaningAreas,
      depositLocation,
      preferredServiceDays,
      miscellaneous,
      geo_location,
      rawAddress,
    } = this.state;

    function isAddressNotEmpty() {
      if(
          location?.address?.length > 0
          || location?.city?.length > 0
          || location?.state?.length > 0
          || location?.zip_code?.length > 0
      ) {
        return true;
      }
      return false;
    }

    // const { service } = this.props;
    const schema = yup.object().shape({
      ...((!geo_location || isAddressNotEmpty()) && {
        location: yup.object().shape({
          address: yup.string().required('Address is required.'),
          city: yup.string().required('city is required.'),
          state: yup.string().required('state is required.'),
          zip_code: yup.string().required('zip code is required.'),
        })
      }),
      regularity: yup.string().required("Regularity is required"),
      propertySize: yup.string().required("Property size is required"),
      // cleaningAreas: yup.string().required("Cleaning Areas is required"),
      depositLocation: yup.string(),
      preferredServiceDays: yup.array(yup.string()).required("Preferred service days is required"),
      miscellaneous: yup.array(yup.object({
        mis_type:yup.string().oneOf(["product", "service"]).required('Select one'),
        item: yup.string().required('Enter item'),
        price: yup.string().required('Enter price'),
      }))
    });
    const data = {
      location,
      regularity,
      propertySize,
      cleaningAreas,
      depositLocation,
      preferredServiceDays,
      miscellaneous
    };

    // if(!rawAddress && !geo_location) {
    //   this.setState({errors: {"location.address": "Address or geo-coordinates required"}, is_btn_active: false})
    //   return;
    // }

    setTimeout(() => {
      schema.validate(data, { abortEarly: false }).then(() => {
        this.setState({is_btn_active: true, errors: {}});
        // axios.post(`${config.getHost()}service-order/validate_address/`, {
        //   field_office_uuid: service?.field_office_uuid,
        //   address: location?.formatted_address
        // }).then((response) => {
        //   if (Object.keys(response).length > 0 && response?.data?.is_valid) {
        this.onAddService(); 
        //   }      
        // }).catch((error) => {
        //   message.error('Sorry, we could not find that address in OptimoRoute. Please check the address and try again, or enter latitude/longitude coordinates.');
        // });
      }).catch((error) => {
        let err_data = {};
        map(error.inner, (item) => {err_data[item.path] = item.message})
        this.setState({errors: err_data, is_btn_active: false})
      });
    }, 200);
  };

  // on clear
  onClear = () => {
    this.setState({
      location: {
        address: '',
        city: '',
        state: '',
        zip_code: ''
      },
      geo_location: '',
      regularity: '',
      propertySize: '',
      cleaningAreas: '',
      depositLocation: '',
      preferredServiceDays: [],
      securityCode: '',
      notes: '',
      isDoggyDoor: false,
      cleanOutside: false,
      errors: {},
      total_price_per_service: '',
      miscellaneous: [...this.state.org_miscellaneous]
    });
  }

  // on Add Service
  onAddService = () => {
    const {
      tech,
      uuid,
      regularity,
      propertySize,
      cleaningAreas,
      depositLocation,
      preferredServiceDays,
      notes,
      isDoggyDoor,
      cleanOutside,
      location,
      total_price_per_service,
      miscellaneous,
      service_add_ons,
      securityCode,
      geo_location,
      rawAddress
    } = this.state;
    const final_service_add_ons = [];

    map(service_add_ons, obj => {
      if (obj.checked) {
        final_service_add_ons.push({add_on_uuid: obj?.add_on_uuid, add_on_name: obj?.add_on_name, is_recurring: obj?.is_recurring || false})
      }
    });

    const service_unavailable_days = days?.filter(x => !preferredServiceDays?.includes(x)).length !== 7 ?  days?.filter(x => !preferredServiceDays?.includes(x)) : [];

    if (!location?.geo_location) {
      delete location?.geo_location;
    }

    // Axios.get(`https://maps.googleapis.com/maps/api/geocode/json`, {
    //   params: {
    //     ...(!!geo_location ? { latlng: geo_location } : { address: encodeURI(rawAddress) }),
    //     key: process.env.REACT_APP_GOOGLE_PLACE_API_KEY,
    //   }
    // }).then((res) => {
    //   const result = res?.data;
    // const formatted = this.setAddress(result)
    /**
          {"address":"","state":"","city":"","zipcode":""}
       */
    // let service_address_data = {};

    let preferred_technician_uuid = tech ? tech : "0000000-0000-0000-0000-0000000000000";

    let obj = {
      preferred_technician_uuid,
      service_address: ({...this.state?.location, ...(geo_location?.trim() === '' ? {geo_location: null} : {geo_location})}),
      // service_address: (location?.street_number && location?.route) ? {...location, address: `${location?.street_number} ${location?.route}`} : location,
      frequency: regularity,
      property_type: propertySize,
      area_to_clean: cleaningAreas,
      disposal_location: depositLocation,
      cleaning_notes: notes,
      has_doggy_door: isDoggyDoor,
      can_clean_if_dogs_out: cleanOutside,
      service_add_ons: final_service_add_ons,
      total_price_per_visit: total_price_per_service,
      miscallaneous_services: miscellaneous,
      service_unavailable_days,
      security_code: securityCode
    }
  
    if (geo_location) {
      Object.assign(obj.service_address, {geo_location: {latitude: geo_location?.split(',')?.[0]?.trim(), longitude: geo_location?.split(',')?.[1]?.trim() }})
    }
    // if (service_unavailable_days.length > 0) {
    //   Object.assign(obj, {service_unavailable_days})
    // }
  
    this.props.editService(uuid, obj);
    setTimeout(() => this.props.getServiceOrder({user__uuid: this.props.customerId}), 1000);
    this.props.closeDrawer();
    //this.props.onEditSuccess && this.props.onEditSuccess();
    // this.onClear();

    this.props.onEditSuccess && this.props.onEditSuccess();
    this.setState({
      renderErrorFromProps: true
    });
  };

  // on add ons change
  onAddOnsChange = (e, item, type) => {
    let {service_add_ons, total_addons} = this.state;
    const idx = service_add_ons?.findIndex(x => x.add_on_uuid === item?.uuid)
    if (type === 'bool') {
      if (idx > -1) {
        service_add_ons.splice(idx, 1)
        total_addons -= item?.cost_per_visit
      } else {
        total_addons += item?.cost_per_visit
        service_add_ons.push({...item, add_on_uuid: item?.uuid, add_on_name: item?.name, [e.target.name]: e.target.checked})
      }
    } else {
      if (idx > -1) {
        Object.assign(service_add_ons[idx], {[e.target.name]: e.target.value});
      }
    }
    this.setState({service_add_ons, total_addons}, () => this.priceCalc());
  }

  // render add ons
  renderAddOn = (item, index) => {
    const {service_add_ons} = this.state;
    const currentAddOn = service_add_ons?.find(obj => obj.add_on_uuid === item.uuid)
    const eachVisit = !isEmpty(currentAddOn) ? currentAddOn?.is_recurring : false;
    const firstVisit = !isEmpty(currentAddOn) ? !currentAddOn?.is_recurring : false;

    if (item?.is_active) {
      return (
        <div className="mb-10 flex" key={`checkboxAddons${index}`}>
          <div className="fitem-check">
            <input
              type="checkbox"
              className="fitem-ck-input"
              id={`checkboxAddons${index}`}
              name={`checked`}
              checked={currentAddOn?.checked}
              onChange={(e) => this.onAddOnsChange(e, item, 'bool')}
            />
            <label htmlFor={`checkboxAddons${index}`} className="fitem-ck-txt">
              {`${item?.name}`} <br/>
              +{item?.cost_per_visit} per visit
              <strong>{item?.comment}</strong>
            </label>
          </div>
          <div className="flex">
            <button
              // disabled={!currentAddOn?.checked}
              className={`btn btn-disabled xs-btn ${(currentAddOn?.checked && firstVisit) ? 'btn-warning' : ''}`} //${!currentAddOn?.checked ? 'disabled' : ''}
              onClick={() => this.onAddOnsChange({target: {name: 'is_recurring', value: false}}, item)}>One-Time</button>
            <button
              // disabled={!currentAddOn?.checked}
              className={`btn btn-disabled xs-btn ${(currentAddOn?.checked && eachVisit) ? 'btn-warning' : ''}`} //${!currentAddOn?.checked ? 'disabled' : ''}
              onClick={() => this.onAddOnsChange({target: {name: 'is_recurring', value: true}}, item)}
            >Recurring</button>
          </div>

        </div>
      )
    }
  };

  // render all state
  renderAllState = () => {
      return AllState.AllState.map((item, i) => {
        return (<Option value={item.abbreviation} key={i}>{item.name}</Option>)
    });
  }

  onAddressChange = (e) => {
    const {location} = this.state;
    Object.assign(location, {[e.target.name]: e.target.value})
    this.setState({location, errors: {}});
  };

  onMiscellaneousItemError = (item_index) => {
    const {errors} = this.state;
    let error_index = errors?.miscellaneous?.findIndex(item => item.index === item_index && item.name === "price" );

    if(error_index !== undefined && !(error_index < 0))
    {
      return <label className="new_err_msg">
        <i className="las la-info-circle" />
          {errors?.miscellaneous[error_index]?.message}
      </label>
    }
  }

  render() {
    const {closeDrawer, visible} = this.props;
    const {
      tech,
      tech_list,
      regularity,
      propertySize,
      cleaningAreas,
      depositLocation,
      preferredServiceDays,
      securityCode,
      notes,
      addOns,
      location,
      errors,
      total_price_per_service,
      miscellaneous,
      loader,
      geo_location,
      total_price_per_service_incl_miscellaneous,
      total,
      is_address_manually
    } = this.state;

    let address = location?.address ? `${location?.address}` : '';
    address += location?.city ? `, ${location?.city}` : '';
    address += location?.state ? `, ${location?.state}` : '';
    address += location?.zip_code ? `, ${location?.zip_code}` : '';

    return (
      <Drawer
        placement={'right'}
        closable={false}
        onClose={closeDrawer}
        visible={visible}
        key={'right'}
        width={'525'}
        className="drawer-wrapper"
      >
        <div className="edit-service-drawer  rdrawer">
          {loader && <Loader />}
          <div className="card-head flex ai-center">
            <h4>Edit Service</h4>
            <CloseOutlined onClick={closeDrawer}/>
          </div>
          <div  className="card-row flex flex-column">
            <div className="card-full">
              <div className="form-group">
                <div className="fitem">
                  <label htmlFor="address">Service Address</label>
                  <div className="google_search_place">

                    <input
                      autoComplete="off"
                      type="text"
                      ref="address"
                      placeholder={"Address"}
                      name="google_address"
                      id="google_address"
                      onChange={(e) => {
                        if (!e.target.value) {
                          this.setState({
                            location: { address: '', state: '', city: '', zip_code: '' },
                          })
                        }
                      }}
                      disabled={is_address_manually}
                    />
                    <b>or <a href="/" onClick={(e) => {
                      e.preventDefault();
                      this.setState({
                        is_address_manually: true,
                      })
                    }}><u>enter address manually</u></a></b>
                  </div>
                  {
                    is_address_manually &&
                      <div className="manually_address">
                        <a href="/#" onClick={(e) => {
                          e.preventDefault();
                          this.setState({
                            is_address_manually: false,
                            // location: { address: '', state: '', city: '', zip_code: '' },
                          })
                        }}><img src={cross_icon} alt="" className="float-right mb-10" /></a>
                        <br />

                        <div className="form-group mb-20">
                          <div className="fitem">
                            <input
                              type="text"
                              placeholder="Address"
                              name="address"
                              value={location?.address}
                              onChange={(e) => this.onAddressChange(e)}
                            />
                          </div>
                          <div className="half-fitem fitem">
                            <div className="half-fitem fitem">
                              <input
                                type="text"
                                placeholder="City"
                                name="city"
                                value={location?.city}
                                onChange={(e) => this.onAddressChange(e)}
                              />
                            </div>
                            <div className="half-fitem fitem">
                              <Select
                                showArrow={true}
                                name="state"
                                placeholder="State"
                                onChange={(value) => this.onAddressChange({ target: { name: 'state', value: value } })}
                                value={location?.state || undefined}
                                virtual={false}
                              >
                                {this.renderAllState()}
                              </Select>
                            </div>
                            <div className="half-fitem fitem">
                              <input
                                type="text"
                                className='form--control'
                                placeholder="ZIP Code"
                                name="zip_code"
                                maxLength={5}
                                minLength={5}
                                onChange={(e) => this.onNumericInputChange(e.target.value) && this.onAddressChange(e)}
                                value={location?.zip_code || ''}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                  }
                  {((errors?.['location.address'] || errors?.['location.city'] || errors?.['location.state'] || errors?.['location.zip_code']) && !loader)?
                    <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.['location.address'] || errors?.['location.city'] || errors?.['location.state'] || errors?.['location.zip_code'] || 'Address is required'}</label> : ''}
                </div>
                <div className="fitem">
                  <input
                    type="text"
                    ref="startLocation"
                    placeholder={'Latitude, Longitude'}
                    name="geo_location"
                    id="geo_location"
                    value={geo_location || ''}
                    onChange={(e) => this.onGeolocationChanged(e)}
                  />
                </div>
                <div className="fitem half-fitem">
                  <div className="fitem half-fitem">
                    <label>Regularity</label>
                    <Select
                      showArrow
                      virtual={false}
                      style={{ width: '100%' }}
                      value={regularity || undefined}
                      onChange={(e) => this.onTextChange({target: {name: 'regularity', value: e}})}
                    >
                      {
                        FREQUENCY_MAPPING?.map(obj => <Option value={obj.value} key={obj.value}>{obj.key}</Option>)
                      }
                    </Select>
                    {errors?.['regularity'] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.['regularity']}</label> : ''}
                  </div>
                  <div className="fitem half-fitem">
                    <label>Property Size</label>
                    <Select
                      showArrow
                      virtual={false}
                      style={{ width: '100%' }}
                      value={propertySize || undefined}
                      onChange={(e) => this.onTextChange({target: {name: 'propertySize', value: e}})}
                    >
                      {PROPERTY_TYPE_MAPPING?.map(obj => <Option value={obj.value} key={obj.value}>{obj.key}</Option>)}
                    </Select>
                    {errors?.['propertySize'] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.['propertySize']}</label> : ''}
                  </div>
                </div>
                <div className="fitem half-fitem">
                  <div className="fitem half-fitem">
                    <label>Cleaning Areas</label>
                    <Select
                      showArrow
                      virtual={false}
                      style={{ width: '100%' }}
                      value={cleaningAreas || undefined}
                      mode="multiple"
                      allowClear
                      onChange={(e) => this.onTextChange({target: {name: 'cleaningAreas', value: e}})}
                    >
                      {
                        formattedAreas?.map(obj => <Option value={obj.value} key={`cleaningAreas${obj.value}`}>{obj.display}</Option>)
                      }
                    </Select>
                    {errors?.['cleaningAreas'] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.['cleaningAreas']}</label> : ''}
                  </div>
                  <div className="fitem half-fitem">
                    <label>Deposit Location</label>
                    <input
                      type="text"
                      className={'form-control mb-10'}
                      placeholder={'Deposit Location'}
                      name="depositLocation"
                      id="depositLocation"
                      value={depositLocation || ''}
                      onChange={(e) => this.onTextChange(e)}
                    />
                    {errors?.['depositLocation'] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.['depositLocation']}</label> : ''}
                  </div>
                </div>
                <div className="fitem">
                  <label style={{ 'textTransform': 'none' }}>Preferred Service Day(s)</label>
                  <Select
                    mode="multiple"
                    showArrow
                    virtual={false}
                    style={{ width: '100%' }}
                    value={preferredServiceDays || undefined}
                    name={"preferredServiceDays"}
                    onChange={(e) => this.onTextChange({target: {name: 'preferredServiceDays', value: e}})}
                  >
                    <Option value={'any'}>{'Any'}</Option>
                    <Option value={'sun'}>{'Sunday'}</Option>
                    <Option value={'mon'}>{'Monday'}</Option>
                    <Option value={'tues'}>{'Tuesday'}</Option>
                    <Option value={'wed'}>{'Wednesday'}</Option>
                    <Option value={'thurs'}>{'Thursday'}</Option>
                    <Option value={'fri'}>{'Friday'}</Option>
                    <Option value={'sat'}>{'Saturday'}</Option>
                  </Select>
                  {errors?.['preferredServiceDays'] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.['preferredServiceDays']}</label> : ''}
                </div>
              </div>
              <div className="form-group">
                <label className="black">Miscellaneous</label>
                {
                  miscellaneous.length === 0 && <React.Fragment><br /><label>No Miscellaneous items.</label><br/><label className="black"><a className="flex ai-center" onClick={() => this.onMiscellaneousItemAdd()}><img className="icoimg ml-0 mr-5" src={plus_icon_green} alt="" /> <strong>Add Item</strong></a></label></React.Fragment>
                }
                {map(miscellaneous, (obj, index) => {
                  return (
                    <div key={`miscellaneous${index}`} className={'flex'}>
                      <div className="fitem">
                        <label htmlFor={"item"}>Type</label>
                        <Select
                          showArrow
                          virtual={false}
                          style={{ width: '100%' }}
                          value={obj?.mis_type?obj?.mis_type:"Select Type"}
                          onChange={(e) => this.onMiscellaneousItemChanged({target: {name: 'mis_type', value: e}},index)}
                        >
                          <Option value="product" id="product">Product</Option>
                          <Option value="service" id="service">Service</Option>
                        </Select>
                        {errors?.[`miscellaneous[${index}].mis_type`] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.[`miscellaneous[${index}].mis_type`]===`miscellaneous[${index}].mis_type must be one of the following values: product, service`?"Select one":errors?.[`miscellaneous[${index}].mis_type`]}</label> : ''}
                      </div>
                      <div className="fitem" style={{marginLeft: "10px"}}>
                        <label htmlFor={"item"}>Item</label>
                        <input
                          type="text"
                          className={'form-control'}
                          placeholder={'Item'}
                          name="item"
                          id="item"
                          value={obj?.item}
                          onChange={(e) => this.onMiscellaneousItemChanged(e, index)}
                        />
                        {errors?.[`miscellaneous[${index}].item`] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.[`miscellaneous[${index}].item`]}</label> : ''}
                      </div>
                      <div className="fitem" style={{marginLeft: "10px"}}>
                        <label htmlFor={"price"}>Price</label>
                        <CurrencyFormat
                          name="price"
                          value={obj?.formatted_price}
                          thousandSeparator={true}
                          prefix={'$'}
                          decimalSeparator={"."}
                          decimalScale={2}
                          fixedDecimalScale={true}
                          allowNegative={true}
                          placeholder={"0.00"}
                          onValueChange={(values) => {
                            const { formattedValue, value, floatValue } = values;
                            this.onMiscellaneousPriceChange(floatValue, index, formattedValue);
                            return this.onNumericInputChange(value);
                          }} 
                        />
                        {
                          this.onMiscellaneousItemError(index)
                        }
                      </div>
                      {(miscellaneous?.length - 1) === index ?<img className="icoimg_mis_type" onClick={(e) => {e.preventDefault(); this.onMiscellaneousItemAdd() }} src={plus_icon} alt="" /> : ''}
                      {(index >= 0) ?<img className="icoimg_mis_type float-right" onClick={(e) => {e.preventDefault(); this.onMiscellaneousItemRemove(index)}} src={cross_icon} alt="" />: ''}
                    </div>
                  )
                })}
              </div>
              <div className="fitem">
                <label htmlFor={"total_price_per_service"}>Total price per visit</label>
                <input
                  type="text"
                  className={'form-control mb-10'}
                  placeholder={'Total price per visit'}
                  name="total_price_per_service"
                  id="total_price_per_service"
                  value={total_price_per_service}
                  onChange={(e) => this.onTextChange(e)}
                  disabled={true}
                />
              </div>
              <div>
                <h4>Total (Incl. miscellaneous price): {formatToCurrency(total)}</h4>
              </div>
              <div className="form-group">
                <label className="black">Do we need a security code to access this building?</label>
                <div className="fitem">
                  <label htmlFor={"securityCode"}>Security Code</label>
                  <input
                    type="text"
                    className={'form-control mb-10'}
                    placeholder={'Security code for the door'}
                    name="securityCode"
                    id="securityCode"
                    value={securityCode}
                    onChange={(e) => this.onTextChange(e)}
                  />
                </div>
                <div className="fitem">
                  <label htmlFor={"notes"}>Notes</label>
                  <input
                    type="text"
                    className={'form-control'}
                    placeholder={'Enter any additional service notes here'}
                    name="notes"
                    id="notes"
                    value={notes}
                    onChange={(e) => this.onTextChange(e)}
                  />
                </div>
                {/*<span className="text-center d-block">*/}
                {/*  <button className="btn plain-btn danger" onClick={() => {*/}
                {/*    this.setState({loader: true})*/}
                {/*    setTimeout(() => {*/}
                {/*      this.props.pauseService({*/}
                {/*        service_order_uuid: uuid,*/}
                {/*        understand_pause_func: false,*/}
                {/*        pause_from: moment().format('YYYY-MM-DD'),*/}
                {/*        pause_to: null,*/}
                {/*        suspend_until_manual: true*/}
                {/*      })*/}
                {/*    }, 1000)*/}
                {/*  }}>Suspend this service</button>*/}
                {/*</span>*/}

              </div>
            </div>
            <hr className="d-block w-100" />
            <div className="card-full pt-0">
              <div className="d-block mt-10">
                <h4 className="mb-0">Add-ons</h4>
                <span className="mb-10 lbltxt">Add-ons will be added to next service date.</span>
                <div className="d-block mt-30">
                  {addOns?.map(this.renderAddOn)}
                </div>
                {/*<div className="fitem-check">*/}
                {/*  <input*/}
                {/*    type="checkbox"*/}
                {/*    className="fitem-ck-input"*/}
                {/*    id={`isDoggyDoor`}*/}
                {/*    name={`isDoggyDoor`}*/}
                {/*    checked={isDoggyDoor}*/}
                {/*    onChange={(e) => this.onTextChange(e, 'bool')}*/}
                {/*  />*/}
                {/*  <label htmlFor={`isDoggyDoor`} className="fitem-ck-txt">{'Is there a doggy door?'}</label>*/}
                {/*</div>*/}
              </div>
            </div>
            <div className="card-full pt-0">
              <div className="d-block mt-10">
                <div className="fitem mt-10">
                  <b className="d-block mb-10">Preferred Technician</b>
                  <Select
                    value={tech && tech_list?.results?.length > 0 ? tech : undefined}
                    showArrow
                    allowClear={true}
                    virtual={false}
                    placeholder={'Select Technician'}
                    style={{ width: '100%' }}
                    onChange={(e) => {
                      this.setState({tech: e ? e : null})
                    }}
                  >
                    <Option value="0000000-0000-0000-0000-0000000000000">Un-Assigned</Option>
                    {map(tech_list?.results, obj => (
                      <Option
                        key={obj?.uuid}
                        value={obj?.uuid}
                      >
                        {obj?.user?.last_name ? `${obj?.user?.first_name} ${obj?.user?.last_name}` : obj?.user?.first_name}
                      </Option>
                    ))}
                  </Select>
                </div>
              </div>
            </div>

            {/*<hr className="d-block w-100" />*/}
            {/*<div className="card-full pt-0">*/}
            {/*  <div className="d-block mt-10">*/}
            {/*    <div className="fitem-check">*/}
            {/*      <input*/}
            {/*        type="checkbox"*/}
            {/*        className="fitem-ck-input"*/}
            {/*        id={`cleanOutside`}*/}
            {/*        name={`cleanOutside`}*/}
            {/*        checked={cleanOutside}*/}
            {/*        onChange={(e) => this.onTextChange(e, 'bool')}*/}
            {/*      />*/}
            {/*      <label htmlFor={`cleanOutside`} className="fitem-ck-txt">{'Can we clean with your dogs outside?'}</label>*/}
            {/*    </div>*/}
            {/*    {`If No, we'll ring the bell before cleaning if the dog are outside.`}*/}
            {/*  </div>*/}
            {/*</div>*/}
          </div>
          <div className="footer">
            <button
              type="button"
              className="btn btn-brand btn-bdr"
              onClick={() => {this.onClear(); closeDrawer()}}
            >Cancel</button>
            <button
              // type="submit"
              className={`btn btn-primary`}
              // disabled={!is_btn_active}
              onClick={() => this.validate()}>
              Update Service
            </button>
          </div>
        </div>
      </Drawer>

    )
  }
}

export default EditService;
